export const api = {
  noticeClassify: { // 公告分类模块
    addNoticeCategory: '/cms/addNoticeCategory/addNoticeCategory', // 添加公告分类信息
    updateNoticeCategory: '/cms/addNoticeCategory/updateNoticeCategory', // 修改公告分类信息
    deleteNoticeCategory: '/cms/addNoticeCategory/deleteNoticeCategory', // 删除公告分类信息
    queryNoticeCategoryList: '/cms/queryNoticeCategory/queryNoticeCategoryList', // 查询所有公告分类信息列表
  },
  notice: {
    uploadFile: "/common/file/batchFileload.json",// 上传文件
    queryPersonnelList: '/cms/account/queryResultsByPag.json', // 查询所有的人员信息
    queryDeptTree: 'vas/dept/queryDeptTree.json', // 查询所有部门和部门下面的人员信息接口
    queryPersonnelListByDeptCode: '/cms/queryNotice/queryPersonnelListByDeptCode', // 查询部门下面的人员信息
    addNotice: '/cms/addNotice/addNotice', // 新增公告信息
    updateNotice: '/cms/addNotice/updateNotice', // 修改公告信息
    queryNoticeList: '/cms/queryNotice/queryNoticeList', // 分页查询公告信息列表
    publishNotice: '/cms/addNotice/publishNotice', // 发布公告信息
    deleteNotice: '/cms/addNotice/deleteNotice', // 删除公告信息
  }
}